import { render, staticRenderFns } from "./add.vue?vue&type=template&id=5267cc9e&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=5267cc9e&prod&lang=less&scoped=true&"
import style1 from "./add.vue?vue&type=style&index=1&id=5267cc9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5267cc9e",
  null
  
)

export default component.exports